import * as React from 'react';

function SvgMastercardColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.471 21.408h7.02V8.792h-7.02v12.616z"
        fill="#F16522"
      />
      <mask
        id="MastercardColourSquare_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={7}
        width={13}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 7.076h12.982v16.048H2V7.076z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#MastercardColourSquare_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.917 15.1a8.01 8.01 0 013.065-6.308 8.024 8.024 0 100 12.616 8.01 8.01 0 01-3.065-6.308z"
          fill="#E41B24"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.713 20.072v-.312h-.081l-.093.215-.094-.215h-.081v.312h.057v-.235l.088.203h.06l.087-.204v.236h.057zm-.515 0v-.259h.104v-.052h-.265v.052h.104v.259h.057zm.766-4.972a8.023 8.023 0 01-12.982 6.308 8.009 8.009 0 003.065-6.309 8.01 8.01 0 00-3.065-6.308A8.023 8.023 0 0127.963 15.1z"
        fill="#F89E1B"
      />
    </svg>
  );
}

export default SvgMastercardColourSquare;
